<template>
    <div class="row align-items-center py-2 discountRow no-gutters">
        <div class="col-11 col-md-4 mb-2 mb-md-0">
                <span class="note-beta mr-1">{{ creditMessage }}</span>
            </div>
            <!-- remove cross on mobile -->
            <div class="text-right ico--fix-7n d-md-none col-1" v-if="creditsApplied">
                <button class="remove-cross remove-cross-small" @click="remove"></button>
            </div>
            <div class="col-md-5 mb-2 mb-md-0">
                <label class="custom-formField mb-0 mr-8">
                    <input type="checkbox" v-model="creditsApplied" @change="setApplyCredits()">
                    <span> {{$t('components.BasketCreditRow.applyCredits')}}</span>
                </label>
            </div>
        <div class="col-md-3 text-right" :class="{'loading' : isLoading }">
            <div class="d-flex align-items-center justify-content-end">
                <div class="title text-nowrap text-transform-initial">{{ $nf(discountPriceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</div>
                <div class="remove-cross-wrap d-none d-md-block ico-fix-4n">
                    <div v-if="creditsApplied" class="">
                        <button class="remove-cross remove-cross-small" @click="remove"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['basket'],
        data: function () {
            return {
                creditsApplied: this.getUser().creditsApplied
            };
        },
        computed: {
            creditMessage: function () {
                const user = this.getUser();
                if (!user) {
                    return '';
                }
                let credits = this.$nf(user.credits, 'currency' + this.currencyCode, 'cs-CZ');
                return this.$t('components.BasketCreditRow.creditMessage', {credits: credits});
            },
            creditValidityMessage: function () {
                const user = this.getUser();
                if (!user || !user.creditsExpireDate) {
                    return '';
                }
                return this.$t('components.BasketCreditRow.creditValidityMessage', {creditsExpireDate: user.creditsExpireDate});
            },
            discountPriceWithVat: function () {
                const user = this.getUser();
                if (!user || !user.creditsDiscount) {
                    return '';
                }
                return -user.creditsDiscount;
            },
            currency: function () {
                return this.basket.totalPrice.currency.htmlString;
            },
            currencyCode: function () {
                return this.basket.totalPrice.currency.code;
            },
            isLoading: function () {
                return this.$store.getters.isLoadingCredits;
            }
        },
        methods: {
            getUser: function () {
                return this.$store.getters.user;
            },
            setApplyCredits: function () {
                const val = this.creditsApplied;
                this.$store.dispatch("setApplyCredits", {value: val});
            },
            remove: function () {
                this.creditsApplied = false;
                this.$store.dispatch("setApplyCredits", {value: this.creditsApplied});
            }
        }
    }
</script>
